import { put, call, all, takeLatest, delay } from 'redux-saga/effects';

import {
  GET_CHAT_GPT_SUMMARY,
  SG_GET_CHAT_GPT_SUMMARY,
  SG_GET_CHAT_GPT_SUMMARY_MULTI,
  PENDING_CHAT_GPT_SUMMARY,
  ALL_ERRORS,
} from 'constants/actions.js';

import * as api from 'constants/api.js';

function* getChatGptSummary(action) {
  yield put({ type: PENDING_CHAT_GPT_SUMMARY });
  const maxAttempts = 3;
  const baseDelayMs = 1200;
  let lastError = null;
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    try {
      const json = yield call(api.GET_CHAT_GPT_SUMMARY, action.payload);
      yield put({ type: GET_CHAT_GPT_SUMMARY, payload: json.data });
      return;
    } catch (e) {
      lastError = e;
      if (attempt < maxAttempts - 1) {
        const wait = baseDelayMs * Math.pow(2, attempt);
        yield delay(wait);
        continue;
      }
    }
  }
  // Final failure: surface error and provide a non-empty response string to unblock UI flows
  const token = action?.payload?.token;
  const errorPayload = {
    payload: action?.payload?.payload,
    response: `ERROR: ${lastError?.message || 'Unknown error'}`,
    error: lastError?.response?.data?.error || lastError?.message || 'Request failed',
    status: lastError?.response?.status || 500,
    message: lastError?.response?.data?.message || 'unable to process',
    token,
  };
  yield put({ type: ALL_ERRORS, message: lastError });
  yield put({ type: GET_CHAT_GPT_SUMMARY, payload: errorPayload });
}

export function* loadChatGptSummary() {
  yield takeLatest(SG_GET_CHAT_GPT_SUMMARY, getChatGptSummary);
}

function* getChatGptSummaryMulti(action) {
  yield put({ type: PENDING_CHAT_GPT_SUMMARY });
  const maxAttempts = 3;
  const baseDelayMs = 1200;
  let lastError = null;
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    try {
      const json = yield call(api.GET_CHAT_GPT_SUMMARY_MULTI, action.payload);
      yield put({ type: GET_CHAT_GPT_SUMMARY, payload: json.data });
      return;
    } catch (e) {
      lastError = e;
      if (attempt < maxAttempts - 1) {
        const wait = baseDelayMs * Math.pow(2, attempt);
        yield delay(wait);
        continue;
      }
    }
  }
  const token = action?.payload?.token;
  const errorPayload = {
    payload: action?.payload?.payload,
    response: `ERROR: ${lastError?.message || 'Unknown error'}`,
    error: lastError?.response?.data?.error || lastError?.message || 'Request failed',
    status: lastError?.response?.status || 500,
    message: lastError?.response?.data?.message || 'unable to process',
    token,
  };
  yield put({ type: ALL_ERRORS, message: lastError });
  yield put({ type: GET_CHAT_GPT_SUMMARY, payload: errorPayload });
}


export function* loadChatGptSummaryMulti() {
  yield takeLatest(SG_GET_CHAT_GPT_SUMMARY_MULTI, getChatGptSummaryMulti);
}

export default function* index() {
  yield all([loadChatGptSummary(), loadChatGptSummaryMulti()]);
}
